module.exports = __webpack_public_path__ + "7240ce1841ef748dbd8cae00b0d0dfaa.MP3";